<form [signalForm]="configForm" class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Configuration
    </h3>
    <lib-signal-text-field
      label="Label"
      [formField]="configForm.label" />
    <lib-signal-text-field
      label="Placeholder"
      [formField]="configForm.placeholder" />
    <lib-signal-text-field
      label="Default value"
      hint="Automatically filled when the form opens. Respondents can change it."
      placeholder="Enter a default value"
      [formField]="configForm.defaultValue" />
    <lib-signal-text-field
      label="Help text"
      placeholder="Shown under the field"
      [formField]="configForm.helpText" />
    <lib-signal-dropdown
      label="Rows"
      [items]="textareaRowsOptions"
      valuePath="value"
      displayPath="label"
      [formField]="configForm.rows" />
    <lib-signal-dropdown
      label="Resize"
      [items]="textareaResizeOptions"
      valuePath="value"
      displayPath="label"
      [formField]="configForm.resize" />
    <lib-signal-number-field
      label="Character limit"
      [numberMin]="1"
      [formField]="configForm.characterLimit" />
    <lib-signal-checkbox
      label="Show character counter"
      hint="Show the current character count to the respondent"
      [formField]="configForm.showCharacterCounter" />
  </section>
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Validators
    </h3>
    <lib-signal-checkbox
      label="Required"
      hint="Respondent must fill this field"
      [formField]="configForm.required" />
    <div class="grid gap-3 sm:grid-cols-2">
      <lib-signal-number-field
        label="Min length"
        [numberMin]="0"
        [formField]="configForm.minLength" />
      <lib-signal-number-field
        label="Max length"
        [numberMin]="0"
        [formField]="configForm.maxLength" />
    </div>
    <lib-signal-text-field
      label="Pattern (regex)"
      placeholder="e.g. ^[A-Za-z]+$"
      [formField]="configForm.pattern" />
    <lib-signal-text-field
      label="Custom error message"
      placeholder="Shown when validation fails"
      [formField]="configForm.customMessage" />
  </section>
</form>
